import { useBotbRAFContext } from "@/app/(custom-header)/botb-refer-a-friend/context";
import FriendsInvited from "@/app/(custom-header)/botb-refer-a-friend/components/FriendsInvited";
import QualifyProgress from "@/app/(custom-header)/botb-refer-a-friend/components/QualifyProgress";
import Prizes from "@/app/(custom-header)/botb-refer-a-friend/components/Prizes";
import LockIcon from "@/app/shared-components/icons/LockIcon";
import { useTimer } from "@/app/hooks/useTimer";
import { useIsMobile } from "@/app/redux/features/device/selectors";

function ReferDraw() {
  const { rafStatus, minimumReferralsForGrantPrize, loading } = useBotbRAFContext();

  const isMobile = useIsMobile();

  const t: any = {
    title: (
      <>
        🏆 The £100k Refer a <span className="whitespace-nowrap">Friend Draw</span>
      </>
    ),
    timeLeft: "TIME LEFT",
    days: "DAYS",
    desc: (
      <>
        Invite {minimumReferralsForGrantPrize} friends & unlock
        <br className={"lg:hidden"} /> this exclusive draw:
      </>
    ),
    textQualified: "🎉 You’re qualified! 🎉",
  };

  const timer = useTimer("rewardTimer", rafStatus.endDate * 1000, undefined, "millisecond");

  const isQualified = loading ? false : rafStatus.referredFriends >= minimumReferralsForGrantPrize;

  // TODO
  // Aici credca trebuie un loading pe toata zona .. ca altfel flicare din necalificat in calificat...
  const RafEnabled = rafStatus?.endDate * 1000 - new Date().getTime() > 0;
  return (
    <div className="w-full max-w-[694px] flex flex-col items-center gap-2.5 lg:gap-4 font-jost">
      <div
        className={
          "self-stretch text-primary text-base font-bold leading-[22px] lg:text-2xl lg:font-semibold lg:leading-[30px]"
        }>
        {t.title}
      </div>
      <div
        className={`w-full flex flex-col p-2 lg:p-6 border border-black/8 bg-white rounded-lg border-solid relative ${isQualified ? "px-3.5 py-4.5" : "p-2"}`}>
        <div
          className={
            "absolute -right-px -top-px bg-[#303030] px-[11px] min-h-4.5 lg:px-3 lg:py-1 flex-center rounded-tr-lg rounded-bl-lg"
          }>
          <div
            className={
              "flex items-center gap-1 text-center text-white text-[10px] italic font-bold leading-normal tracking-[-0.5px] lg:text-sm"
            }>
            {RafEnabled ? (
              <>
                <div>{t.timeLeft}:</div>
                <div className={"text-[#FEDA00]"}></div>
                {timer.isPastADay ? (
                  <div>
                    {timer.days} {timer.days === "01" ? "DAY" : "DAYS"}
                  </div>
                ) : (
                  <div className={"flex gap-1"}>
                    <div>{timer.hours}h</div>
                    <div>:</div>
                    <div>{timer.minutes}m</div>
                    <div>:</div>
                    <div>
                      <span className={"min-w-3.5 lg:min-w-[18px] inline-flex text-right"}>{timer.seconds}</span>
                      <span className={"text-[9px] lg:text-[11px] min-w-3 lg:min-w-4 inline-flex"}>
                        {Math.floor(timer.milliseconds / 10)
                          .toString()
                          .padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>Results Pending</>
            )}
          </div>
        </div>

        {!isQualified && (
          <>
            <div className={"text-[#28282B] text-xs font-medium leading-4 lg:text-base lg:leading-[22px]"}>
              {t.desc}
            </div>

            <div className={"w-full h-px bg-black/8 my-2 lg:my-4"} />
          </>
        )}

        <div className={`flex justify-between gap-2 lg:gap-6 w-full ${isQualified ? "flex-col" : ""}`}>
          {isQualified ? (
            <div className={"text-[#3DAE44] text-jost text-sm font-medium leading-5 lg:text-lg lg:leading-6"}>
              {t.textQualified}
            </div>
          ) : (
            <div
              className={
                "flex flex-col gap-6 lg:gap-4 max-lg:shrink-0 lg:grow lg:w-full lg:max-w-[235px] justify-between"
              }>
              <FriendsInvited />
              {!isMobile && <QualifyProgress />}
            </div>
          )}

          <div
            className={`flex items-center gap-2 lg:gap-4 lg:w-full relative ${isQualified ? "" : "flex-col lg:w-[335px]"}`}>
            <Prizes isQualified={isQualified} />
            {!isQualified && (
              <div className={"absolute size-full bg-white/70 p-3 flex items-center justify-center rounded-lg"}>
                <div
                  className={"flex justify-center items-center gap-[5px] lg:gap-2 bg-[#F33424] px-3 py-1 rounded-full"}>
                  <LockIcon className={"size-[15px] lg:size-6 shrink-0 text-white"} />
                  <span
                    className={"text-white font-jost text-[10px] font-medium leading-3 lg:text-base lg:leading-[22px]"}>
                    Refer{" "}
                    <span className={`${loading ? "blur-[4px] opacity-50" : ""}`}>
                      {loading
                        ? "0"
                        : minimumReferralsForGrantPrize -
                          (rafStatus.referredFriends > minimumReferralsForGrantPrize
                            ? minimumReferralsForGrantPrize
                            : rafStatus.referredFriends)}
                    </span>{" "}
                    friends to qualify
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        {isMobile && !isQualified && <QualifyProgress inline={true} />}
      </div>
    </div>
  );
}

export default ReferDraw;
